import {SET_SETTINGS} from "../../../constants/EventsConstants";
import {SettingsObject} from "../../../@types/response";

export const SetSettingsAction = (data: SettingsObject) => ({
    type: SET_SETTINGS,
    payload: data
})